import { ManualItem, CategoryItem } from './types';

export const MANUAL_CATEGORIES: CategoryItem[] = [
  { id: 'all', name: 'All Categories' },
  { id: 'profile', name: 'Profile & General' },
  { id: 'attendance', name: 'Attendance (FRAS)' },
  { id: 'leave', name: 'Leave & Encashment' },
  { id: 'identity', name: 'Data & Identity (I-Card)' },
  { id: 'noc', name: 'NOC Certificates' },
  { id: 'tax_reimb', name: 'Tax, Reimbursement & Loan' },
  { id: 'vpf', name: 'VPF Contribution' },
  { id: 'appraisal', name: 'Appraisal (APAR)' },
  { id: 'finance', name: 'Financial & Retirement' },
  { id: 'support', name: 'HR Support & Services' },
  { id: 'holidays', name: 'Holidays & Milestones' },
  { id: 'admin', name: 'Admin & Design' },
  { id: 'chatbot', name: 'Chatbot' },
];

export const S3_MANUAL_ITEMS: ManualItem[] = [
  // ==========================================
  // 1. MANUALS - DMRC HRMS_EMPLOYEES (17 PDFs)
  // ==========================================
  {
    id: 'emp-00',
    fileName: '0. DMRC HRMS - Application Installation Procedure.pdf',
    title: 'DMRC HRMS - Application Installation Procedure',
    parentFolder: '1. Manuals - DMRC HRMS_Employees',
    folderType: 'employee_manual',
    type: 'pdf',
    category: 'profile',
    categoryLabel: 'Installation & Setup',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/1.%20Manuals%20-%20DMRC%20HRMS_Employees/0.%20DMRC%20HRMS%20-%20Application%20Installation%20Procedure.pdf',
    version: 'V1.0',
    fileSize: 'PDF Document',
    description: 'Step-by-step installation instructions for the DMRC HRMS mobile and web applications.',
  },
  {
    id: 'emp-01',
    fileName: '1. Employee Personal Profile and Notifications_V8.0.pdf',
    title: 'Employee Personal Profile and Notifications',
    parentFolder: '1. Manuals - DMRC HRMS_Employees',
    folderType: 'employee_manual',
    type: 'pdf',
    category: 'profile',
    categoryLabel: 'Profile & Notifications',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/1.%20Manuals%20-%20DMRC%20HRMS_Employees/1.%20Employee%20Personal%20Profile%20and%20Notifications_V8.0.pdf',
    version: 'V8.0',
    fileSize: 'PDF Document',
    description: 'Guide for viewing and updating employee personal profile, contact info, and notification center.',
  },
  {
    id: 'emp-02',
    fileName: '2. Attendance Management (FRAS) - Employee Request V7.0.pdf',
    title: 'Attendance Management (FRAS) - Employee Request',
    parentFolder: '1. Manuals - DMRC HRMS_Employees',
    folderType: 'employee_manual',
    type: 'pdf',
    category: 'attendance',
    categoryLabel: 'Attendance (FRAS)',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/1.%20Manuals%20-%20DMRC%20HRMS_Employees/2.%20Attendance%20Management%20%28FRAS%29%20-%20Employee%20Request%20V7.0.pdf',
    version: 'V7.0',
    fileSize: 'PDF Document',
    description: 'Facial Recognition Attendance System (FRAS) daily mark, geo-fencing, and regularize requests.',
  },
  {
    id: 'emp-03',
    fileName: '3. NOC (No Objection Certificates) V7.0.pdf',
    title: 'NOC (No Objection Certificates)',
    parentFolder: '1. Manuals - DMRC HRMS_Employees',
    folderType: 'employee_manual',
    type: 'pdf',
    category: 'noc',
    categoryLabel: 'NOC Services',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/1.%20Manuals%20-%20DMRC%20HRMS_Employees/3.%20NOC%20%28No%20Objection%20Certificates%29%20V7.0.pdf',
    version: 'V7.0',
    fileSize: 'PDF Document',
    description: 'Applying for Passport/Visa NOC, Higher Education NOC, Outside Job and Ex-India Travel approvals.',
  },
  {
    id: 'emp-04',
    fileName: '4. Reimbursement Claims_Advances V1.0.pdf',
    title: 'Reimbursement Claims & Advances',
    parentFolder: '1. Manuals - DMRC HRMS_Employees',
    folderType: 'employee_manual',
    type: 'pdf',
    category: 'tax_reimb',
    categoryLabel: 'Reimbursements',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/1.%20Manuals%20-%20DMRC%20HRMS_Employees/4.%20Reimbursement%20Claims_Advances%20V1.0.pdf',
    version: 'V1.0',
    fileSize: 'PDF Document',
    description: 'Procedures for submitting reimbursement claims, CEA, medical bills, conveyance, and advances.',
  },
  {
    id: 'emp-05',
    fileName: '5. Leave Management Applications V2.0.pdf',
    title: 'Leave Management Applications',
    parentFolder: '1. Manuals - DMRC HRMS_Employees',
    folderType: 'employee_manual',
    type: 'pdf',
    category: 'leave',
    categoryLabel: 'Leave Management',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/1.%20Manuals%20-%20DMRC%20HRMS_Employees/5.%20Leave%20Management%20Applications%20V2.0.pdf',
    version: 'V2.0',
    fileSize: 'PDF Document',
    description: 'Guide for submitting Casual Leave (CL), Earned Leave (EL), Restricted Holidays, and tracking balances.',
  },
  {
    id: 'emp-06',
    fileName: '6. Miscellaneous HR Functions V2.0.pdf',
    title: 'Miscellaneous HR Functions',
    parentFolder: '1. Manuals - DMRC HRMS_Employees',
    folderType: 'employee_manual',
    type: 'pdf',
    category: 'support',
    categoryLabel: 'Miscellaneous HR',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/1.%20Manuals%20-%20DMRC%20HRMS_Employees/6.%20Miscellaneous%20HR%20Functions%20V2.0.pdf',
    version: 'V2.0',
    fileSize: 'PDF Document',
    description: 'Miscellaneous HR services including employee queries, certificates, and salary statements.',
  },
  {
    id: 'emp-07',
    fileName: '7. Employee Data And Identity Management V2.0.pdf',
    title: 'Employee Data And Identity Management',
    parentFolder: '1. Manuals - DMRC HRMS_Employees',
    folderType: 'employee_manual',
    type: 'pdf',
    category: 'identity',
    categoryLabel: 'Identity & I-Card',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/1.%20Manuals%20-%20DMRC%20HRMS_Employees/7.%20Employee%20Data%20And%20Identity%20Management%20V2.0.pdf',
    version: 'V2.0',
    fileSize: 'PDF Document',
    description: 'Application for Smart Identity Card, dependent family member inclusion, and card renewal.',
  },
  {
    id: 'emp-08',
    fileName: '8. VPF Contribution Module V5.0.pdf',
    title: 'VPF Contribution Module',
    parentFolder: '1. Manuals - DMRC HRMS_Employees',
    folderType: 'employee_manual',
    type: 'pdf',
    category: 'vpf',
    categoryLabel: 'VPF Contribution',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/1.%20Manuals%20-%20DMRC%20HRMS_Employees/8.%20VPF%20Contribution%20Module%20V5.0.pdf',
    version: 'V5.0',
    fileSize: 'PDF Document',
    description: 'Voluntary Provident Fund (VPF) monthly contribution amount modification and PF statements.',
  },
  {
    id: 'emp-09',
    fileName: '9. Medical and Leave Encashment Applications V5.0.pdf',
    title: 'Medical and Leave Encashment Applications',
    parentFolder: '1. Manuals - DMRC HRMS_Employees',
    folderType: 'employee_manual',
    type: 'pdf',
    category: 'leave',
    categoryLabel: 'Leave Encashment',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/1.%20Manuals%20-%20DMRC%20HRMS_Employees/9.%20Medical%20and%20Leave%20Encashment%20Applications%20V5.0.pdf',
    version: 'V5.0',
    fileSize: 'PDF Document',
    description: 'Application workflow for medical reimbursement and earned leave encashment claims.',
  },
  {
    id: 'emp-10',
    fileName: '10. Tax, Reimbursement and Loan Management V5.0.pdf',
    title: 'Tax, Reimbursement and Loan Management',
    parentFolder: '1. Manuals - DMRC HRMS_Employees',
    folderType: 'employee_manual',
    type: 'pdf',
    category: 'tax_reimb',
    categoryLabel: 'Tax & Loan Management',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/1.%20Manuals%20-%20DMRC%20HRMS_Employees/10.%20Tax%2C%20Reimbursement%20and%20Loan%20Management%20V5.0.pdf',
    version: 'V5.0',
    fileSize: 'PDF Document',
    description: 'Income Tax declarations, tax card display, loan requests, and surety status monitoring.',
  },
  {
    id: 'emp-11',
    fileName: '11. Admin Portal And Front Page Design V2.0.pdf',
    title: 'Admin Portal And Front Page Design',
    parentFolder: '1. Manuals - DMRC HRMS_Employees',
    folderType: 'employee_manual',
    type: 'pdf',
    category: 'admin',
    categoryLabel: 'Admin & Portal',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/1.%20Manuals%20-%20DMRC%20HRMS_Employees/11.%20Admin%20Portal%20And%20Front%20Page%20Design%20V2.0.pdf',
    version: 'V2.0',
    fileSize: 'PDF Document',
    description: 'Overview of HRMS portal user interface, dashboard navigation, and administration controls.',
  },
  {
    id: 'emp-13',
    fileName: '13. Public Holidays and Employee Milestones V2.0.pdf',
    title: 'Public Holidays and Employee Milestones',
    parentFolder: '1. Manuals - DMRC HRMS_Employees',
    folderType: 'employee_manual',
    type: 'pdf',
    category: 'holidays',
    categoryLabel: 'Holidays & Calendar',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/1.%20Manuals%20-%20DMRC%20HRMS_Employees/13.%20Public%20Holidays%20and%20Employee%20Milestones%20V2.0.pdf',
    version: 'V2.0',
    fileSize: 'PDF Document',
    description: 'DMRC gazetted holidays list, restricted holiday calendar, and service anniversary milestones.',
  },
  {
    id: 'emp-14',
    fileName: '14. Financial and Retirement Benefits Applications V5.0.pdf',
    title: 'Financial and Retirement Benefits Applications',
    parentFolder: '1. Manuals - DMRC HRMS_Employees',
    folderType: 'employee_manual',
    type: 'pdf',
    category: 'finance',
    categoryLabel: 'Retirement & Benefits',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/1.%20Manuals%20-%20DMRC%20HRMS_Employees/14.%20Financial%20and%20Retirement%20Benefits%20Applications%20V5.0.pdf',
    version: 'V5.0',
    fileSize: 'PDF Document',
    description: 'Annual NPS superannuation details, PF statements, gratuity, and retirement benefit forms.',
  },
  {
    id: 'emp-15',
    fileName: '15. Additional HR Support Services V5.0.pdf',
    title: 'Additional HR Support Services',
    parentFolder: '1. Manuals - DMRC HRMS_Employees',
    folderType: 'employee_manual',
    type: 'pdf',
    category: 'support',
    categoryLabel: 'HR Support',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/1.%20Manuals%20-%20DMRC%20HRMS_Employees/15.%20Additional%20HR%20Support%20Services%20V5.0.pdf',
    version: 'V5.0',
    fileSize: 'PDF Document',
    description: 'Employee search directory, internal transfers, grievances, and HR helpdesk services.',
  },
  {
    id: 'emp-17',
    fileName: '17. Employee Appraisal and Performance Management V5.0.pdf',
    title: 'Employee Appraisal and Performance Management (APAR)',
    parentFolder: '1. Manuals - DMRC HRMS_Employees',
    folderType: 'employee_manual',
    type: 'pdf',
    category: 'appraisal',
    categoryLabel: 'APAR & Appraisal',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/1.%20Manuals%20-%20DMRC%20HRMS_Employees/17.%20Employee%20Appraisal%20and%20Performance%20Management%20V5.0.pdf',
    version: 'V5.0',
    fileSize: 'PDF Document',
    description: 'Annual Performance Appraisal Report (APAR) self-assessment submission and score download.',
  },
  {
    id: 'emp-18',
    fileName: '18. Other HR Modules V6.0.pdf',
    title: 'Other HR Modules & Third-Party Access',
    parentFolder: '1. Manuals - DMRC HRMS_Employees',
    folderType: 'employee_manual',
    type: 'pdf',
    category: 'support',
    categoryLabel: 'Other HR Modules',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/1.%20Manuals%20-%20DMRC%20HRMS_Employees/18.%20Other%20HR%20Modules%20V6.0.pdf',
    version: 'V6.0',
    fileSize: 'PDF Document',
    description: 'Application for third-party email access, external software whitelist, and specialty HR tools.',
  },

  // ==========================================
  // 2. MANUALS - DMRC HRMS_COs (6 PDFs)
  // ==========================================
  {
    id: 'co-02',
    fileName: '2. Attendance Management (FRAS) - CO Approval V7.0.pdf',
    title: 'Attendance Management (FRAS) - CO Approval',
    parentFolder: '2. Manuals - DMRC HRMS_COs',
    folderType: 'co_manual',
    type: 'pdf',
    category: 'attendance',
    categoryLabel: 'CO Attendance Approval',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/2.%20Manuals%20-%20DMRC%20HRMS_COs/2.%20Attendance%20Management%20%28FRAS%29%20-%20CO%20Approval%20V7.0.pdf',
    version: 'V7.0',
    fileSize: 'PDF Document',
    description: 'Controlling Officer workflow for verifying and approving employee attendance regularizations.',
  },
  {
    id: 'co-03',
    fileName: '3. NOCs - CO Approval V2.0.pdf',
    title: 'NOCs - CO Approval',
    parentFolder: '2. Manuals - DMRC HRMS_COs',
    folderType: 'co_manual',
    type: 'pdf',
    category: 'noc',
    categoryLabel: 'CO NOC Approval',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/2.%20Manuals%20-%20DMRC%20HRMS_COs/3.%20NOCs%20-%20CO%20Approval%20V2.0.pdf',
    version: 'V2.0',
    fileSize: 'PDF Document',
    description: 'Controlling Officer review, comments, and forwarding of Passport, Visa, and Education NOC requests.',
  },
  {
    id: 'co-07',
    fileName: '7. Employee Data & Identity Management - CO Approval V1.0.pdf',
    title: 'Employee Data & Identity Management - CO Approval',
    parentFolder: '2. Manuals - DMRC HRMS_COs',
    folderType: 'co_manual',
    type: 'pdf',
    category: 'identity',
    categoryLabel: 'CO Identity Approval',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/2.%20Manuals%20-%20DMRC%20HRMS_COs/7.%20Employee%20Data%20%26%20Identity%20Management%20-%20CO%20Approval%20V1.0.pdf',
    version: 'V1.0',
    fileSize: 'PDF Document',
    description: 'Approver guide for verifying dependent family member addition/deletion and Smart I-Card requests.',
  },
  {
    id: 'co-08',
    fileName: '8. VPF Contribution Amount Change - CO Approval V1.0.pdf',
    title: 'VPF Contribution Amount Change - CO Approval',
    parentFolder: '2. Manuals - DMRC HRMS_COs',
    folderType: 'co_manual',
    type: 'pdf',
    category: 'vpf',
    categoryLabel: 'CO VPF Approval',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/2.%20Manuals%20-%20DMRC%20HRMS_COs/8.%20VPF%20Contribution%20Amount%20Change%20-%20CO%20Approval%20V1.0.pdf',
    version: 'V1.0',
    fileSize: 'PDF Document',
    description: 'Controlling Officer review for employee VPF monthly deduction amount updates.',
  },
  {
    id: 'co-09',
    fileName: '9. Medical and Leave Encashment - CO Approval V2.0.pdf',
    title: 'Medical and Leave Encashment - CO Approval',
    parentFolder: '2. Manuals - DMRC HRMS_COs',
    folderType: 'co_manual',
    type: 'pdf',
    category: 'leave',
    categoryLabel: 'CO Leave Approval',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/2.%20Manuals%20-%20DMRC%20HRMS_COs/9.%20Medical%20and%20Leave%20Encashment%20-%20CO%20Approval%20V2.0.pdf',
    version: 'V2.0',
    fileSize: 'PDF Document',
    description: 'Verification and sanctioning of employee medical treatment and leave encashment requests.',
  },
  {
    id: 'co-15',
    fileName: '15. Additional HR Support Services - CO Approval V1.0',
    title: 'Additional HR Support Services - CO Approval',
    parentFolder: '2. Manuals - DMRC HRMS_COs',
    folderType: 'co_manual',
    type: 'pdf',
    category: 'support',
    categoryLabel: 'CO HR Support Approval',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/2.%20Manuals%20-%20DMRC%20HRMS_COs/15.%20Additional%20HR%20Support%20Services%20-%20CO%20Approval%20V1.0',
    version: 'V1.0',
    fileSize: 'PDF Document',
    description: 'CO action workflows for team support, approvals, and personnel service requests.',
  },

  // ==========================================
  // 3. VIDEOS - DMRC HRMS_EMPLOYEES (14 Videos)
  // ==========================================
  {
    id: 'vid-01-chatbot',
    fileName: '1. Chatbot.mp4',
    title: '1. DMRC HRMS Chatbot Assistant Walkthrough',
    parentFolder: '3. Videos - DMRC HRMS_Employees',
    folderType: 'employee_video',
    type: 'video',
    category: 'chatbot',
    categoryLabel: 'Chatbot Guide',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/3.%20Videos%20-%20DMRC%20HRMS_Employees/1.%20Chatbot/1.%20Chatbot.mp4',
    duration: 'Video Guide',
    description: 'Interactive tutorial showing how to use the DMRC AI Chatbot for quick HR queries.',
  },
  {
    id: 'vid-01-login',
    fileName: '1.1 Login Forgot Password OTP Process.mp4',
    title: '1.1 Login, Forgot Password & OTP Verification Process',
    parentFolder: '3. Videos - DMRC HRMS_Employees',
    folderType: 'employee_video',
    type: 'video',
    category: 'profile',
    categoryLabel: 'Login & Password',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/3.%20Videos%20-%20DMRC%20HRMS_Employees/1.%20Employee%20Personal%20Profile%20and%20Notifications/1.1%20Login%20Forgot%20Password%20%20OTP%20Process.mp4',
    duration: 'Video Guide',
    description: 'Step-by-step video guide for employee login, two-step verification, and password reset.',
  },
  {
    id: 'vid-01-police',
    fileName: '1.3 Police Verification Status.mp4',
    title: '1.3 Police Verification Status Tracking',
    parentFolder: '3. Videos - DMRC HRMS_Employees',
    folderType: 'employee_video',
    type: 'video',
    category: 'profile',
    categoryLabel: 'Police Verification',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/3.%20Videos%20-%20DMRC%20HRMS_Employees/1.%20Employee%20Personal%20Profile%20and%20Notifications/1.3%20Police%20Verification%20Status.mp4',
    duration: 'Video Guide',
    description: 'How to check your police verification submission status and renewal intimation.',
  },
  {
    id: 'vid-06-salary',
    fileName: '6.1 Salary Statement.mp4',
    title: '6.1 Monthly Salary Statement & Payslip Download',
    parentFolder: '3. Videos - DMRC HRMS_Employees',
    folderType: 'employee_video',
    type: 'video',
    category: 'finance',
    categoryLabel: 'Salary Statement',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/3.%20Videos%20-%20DMRC%20HRMS_Employees/6.%20Miscellaneous%20HR%20Functions/6.1%20Salary%20Statement.mp4',
    duration: 'Video Guide',
    description: 'Watch how to generate, view, and download monthly bilingual salary slips.',
  },
  {
    id: 'vid-10-tax',
    fileName: '10.1 Display Tax Card.mp4',
    title: '10.1 Display Tax Card & Income Tax Calculation',
    parentFolder: '3. Videos - DMRC HRMS_Employees',
    folderType: 'employee_video',
    type: 'video',
    category: 'tax_reimb',
    categoryLabel: 'Tax Card',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/3.%20Videos%20-%20DMRC%20HRMS_Employees/10.%20Tax%2C%20Reimbursement%20and%20Loan%20Management/10.1%20Display%20Tax%20Card.mp4',
    duration: 'Video Guide',
    description: 'Tutorial demonstrating income tax card display, deductions breakdown, and regime calculation.',
  },
  {
    id: 'vid-10-loan',
    fileName: '10.2 Loan Surety Status.mp4',
    title: '10.2 Loan Surety Status & Verification',
    parentFolder: '3. Videos - DMRC HRMS_Employees',
    folderType: 'employee_video',
    type: 'video',
    category: 'tax_reimb',
    categoryLabel: 'Loan Surety',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/3.%20Videos%20-%20DMRC%20HRMS_Employees/10.%20Tax%2C%20Reimbursement%20and%20Loan%20Management/10.2%20Loan%20Surety%20Status.mp4',
    duration: 'Video Guide',
    description: 'How to monitor employee loan surety standing, co-sign approvals, and balance recovery.',
  },
  {
    id: 'vid-11-admin',
    fileName: '11. Admin Portal and Front Page Design.mp4',
    title: '11. Admin Portal & Front Page Design Navigation',
    parentFolder: '3. Videos - DMRC HRMS_Employees',
    folderType: 'employee_video',
    type: 'video',
    category: 'admin',
    categoryLabel: 'Admin Portal',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/3.%20Videos%20-%20DMRC%20HRMS_Employees/11.%20Admin%20Portal%20and%20Front%20Page%20Design/11.%20Admin%20Portal%20and%20Front%20Page%20Design.mp4',
    duration: 'Video Guide',
    description: 'Visual overview of portal structure, dashboard shortcuts, and system navigation.',
  },
  {
    id: 'vid-13-holidays',
    fileName: '13. Public Holidays and Employee Milestones.mp4',
    title: '13. Public Holidays and Employee Milestones Calendar',
    parentFolder: '3. Videos - DMRC HRMS_Employees',
    folderType: 'employee_video',
    type: 'video',
    category: 'holidays',
    categoryLabel: 'Holidays & Milestones',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/3.%20Videos%20-%20DMRC%20HRMS_Employees/13.%20Public%20Holidays%20and%20Employee%20Milestones/13.%20Public%20Holidays%20and%20Employee%20Milestones.mp4',
    duration: 'Video Guide',
    description: 'Walkthrough of holiday calendar, service tenure milestones, and birthday announcements.',
  },
  {
    id: 'vid-14-nps',
    fileName: '14.2 Annual NPS Super Annuation Detail.mp4',
    title: '14.2 Annual NPS Super Annuation Detail',
    parentFolder: '3. Videos - DMRC HRMS_Employees',
    folderType: 'employee_video',
    type: 'video',
    category: 'finance',
    categoryLabel: 'NPS & Superannuation',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/3.%20Videos%20-%20DMRC%20HRMS_Employees/14.%20Financial%20and%20Retirement%20Benefits%20Applications/14.2%20Annual%20NPS%20Super%20Annuation%20Detail.mp4',
    duration: 'Video Guide',
    description: 'Viewing yearly National Pension System (NPS) employer and employee contributions.',
  },
  {
    id: 'vid-14-pf',
    fileName: '14.3 Annual PF Details.mp4',
    title: '14.3 Annual PF Details & Provident Fund Ledger',
    parentFolder: '3. Videos - DMRC HRMS_Employees',
    folderType: 'employee_video',
    type: 'video',
    category: 'finance',
    categoryLabel: 'PF Details',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/3.%20Videos%20-%20DMRC%20HRMS_Employees/14.%20Financial%20and%20Retirement%20Benefits%20Applications/14.3%20Annual%20PF%20Details.mp4',
    duration: 'Video Guide',
    description: 'How to check annual Provident Fund ledger, interest credits, and withdrawal eligibility.',
  },
  {
    id: 'vid-15-search',
    fileName: '15.2 Employee Search.mp4',
    title: '15.2 Employee Search & Directory Lookup',
    parentFolder: '3. Videos - DMRC HRMS_Employees',
    folderType: 'employee_video',
    type: 'video',
    category: 'support',
    categoryLabel: 'Employee Search',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/3.%20Videos%20-%20DMRC%20HRMS_Employees/15.%20Additional%20HR%20Support%20Services/15.2%20Employee%20Search.mp4',
    duration: 'Video Guide',
    description: 'Searching for colleagues, reporting officers, department wings, and official contact extensions.',
  },
  {
    id: 'vid-17-apar-dl',
    fileName: '17.1 APAR Download.mp4',
    title: '17.1 APAR Download & Performance Rating',
    parentFolder: '3. Videos - DMRC HRMS_Employees',
    folderType: 'employee_video',
    type: 'video',
    category: 'appraisal',
    categoryLabel: 'APAR Download',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/3.%20Videos%20-%20DMRC%20HRMS_Employees/17.%20Employee%20Appraisal%20and%20Performance%20Management/17.1%20APAR%20Download.mp4',
    duration: 'Video Guide',
    description: 'Downloading your evaluated and finalized Annual Performance Appraisal Report.',
  },
  {
    id: 'vid-17-apar-team',
    fileName: '17.2 APAR team status display.mp4',
    title: '17.2 APAR Team Status Display (Reporting Officers)',
    parentFolder: '3. Videos - DMRC HRMS_Employees',
    folderType: 'employee_video',
    type: 'video',
    category: 'appraisal',
    categoryLabel: 'APAR Team Status',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/3.%20Videos%20-%20DMRC%20HRMS_Employees/17.%20Employee%20Appraisal%20and%20Performance%20Management/17.2%20APAR%20team%20status%20display.mp4',
    duration: 'Video Guide',
    description: 'Guide for reporting officers to check team APAR completion and pending submissions.',
  },
  {
    id: 'vid-18-email',
    fileName: '18.9 Application for Third Party E-Mail website Access.mp4',
    title: '18.9 Application for Third Party E-Mail & Website Access',
    parentFolder: '3. Videos - DMRC HRMS_Employees',
    folderType: 'employee_video',
    type: 'video',
    category: 'support',
    categoryLabel: 'Third-Party Access',
    s3Url: 'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/3.%20Videos%20-%20DMRC%20HRMS_Employees/18.%20Other%20HR%20Modules/18.9%20Application%20for%20Third%20Party%20E-Mail%20website%20Access.mp4',
    duration: 'Video Guide',
    description: 'Submitting requisition for external domain email access and IT network permissions.',
  },
];

// Helper: Copy S3 URL to clipboard
export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    } else {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      const successful = document.execCommand('copy');
      textArea.remove();
      return successful;
    }
  } catch (err) {
    console.error('Failed to copy text: ', err);
    return false;
  }
};

// Helper: Trigger Direct S3 Download
export const downloadFileFromS3 = (s3Url: string, fileName?: string) => {
  const link = document.createElement('a');
  link.href = s3Url;
  link.setAttribute('download', fileName || s3Url.split('/').pop() || 'download');
  link.setAttribute('target', '_blank');
  link.setAttribute('rel', 'noopener noreferrer');
  document.body.appendChild(link);
  link.click();
  link.remove();
};
